export default __webpack_public_path__ + "static/media/google-play-badge-fa.f41f484f.png";